/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormGroup, UntypedFormBuilder } from '@angular/forms';
import { Observable, OperatorFunction } from 'rxjs';
import { TypedFormGroup } from '../domain';
import { TypedForm } from '../forms/typed-form';
import { TypedSubmissionForm } from '../forms/typed-submission-form';

@Injectable({
  providedIn: 'root',
})
export class FormFactoryService {
  public constructor(public readonly fb: UntypedFormBuilder) {}

  /**
   *
   * @param controlsConfig FormControls
   * @param submitOperator The operator for submitting the form
   * @param initialValue The initial values of the form (as an obserable or object)
   * @param controlOptions Form options
   * @returns TypedSubmissionForm<FormType, Result>
   */
  public createTypedSubmissionForm<F, R>(
    controlsConfig: Record<string, any> | FormGroup<any>,
    submitOperator: OperatorFunction<F, R>,
    initialValue: Partial<F> | Observable<Partial<F>> = {},
    controlOptions: AbstractControlOptions = {},
  ): TypedSubmissionForm<F, R> {
    const options = this.mergeWithDefaults(controlOptions);
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    const form = (controlsConfig instanceof FormGroup ? controlsConfig : this.fb.group(controlsConfig, options)) as TypedFormGroup<F>;

    return new TypedSubmissionForm<F, R>(form, submitOperator, initialValue);
  }

  /**
   * Same as TypedSubmissionForm, without the submission
   *
   * @param controlsConfig
   * @param initialValue
   * @param controlOptions
   * @returns
   */
  public createTypedForm<F>(
    controlsConfig: Record<string, any>,
    initialValue: Partial<F> | Observable<Partial<F>> = {},
    controlOptions: AbstractControlOptions = {},
  ): TypedForm<F> {
    const options = this.mergeWithDefaults(controlOptions);
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    const form = this.fb.group(controlsConfig, options) as TypedFormGroup<F>;

    return new TypedForm<F>(form, initialValue);
  }

  private mergeWithDefaults(controlOptions: AbstractControlOptions): AbstractControlOptions {
    const defaultOptions: AbstractControlOptions = { updateOn: 'blur' };
    return { ...defaultOptions, ...controlOptions };
  }
}
